export default __webpack_public_path__ + "static/media/demoBoy.8ced176d.svg";